import { createStyles } from '@mantine/emotion';
import { ACTION_PANEL_HEIGHT } from '../../config';

export const useStyles = createStyles((theme) => ({
  root: {
    width: `calc(100% - 48px)`,
    height: `${ACTION_PANEL_HEIGHT}px`,
    padding: `0 ${theme.spacing.sm} 0 ${theme.spacing.sm}`,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.colors.backgroundGray[6]}`,
    borderRadius: '8px 8px 0px 0px',
    backgroundColor: 'white',
    overflowX: 'scroll',

    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },

  scroll: {
    overflow: 'scroll',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    visibility: 'hidden'
  },

  checkbox: {
    display: 'flex',
    marginRight: theme.spacing.md,
    '& input': {
      cursor: 'pointer'
    }
  },
  badge: {
    backgroundColor: theme.colors.backgroundGray[6],
    color: '#344054',
    textTransform: 'none',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    marginRight: theme.spacing.xs,
    borderRadius: '16px',
    cursor: 'pointer',
    padding: `0px ${theme.spacing.xs}`,

    '& .mantine-Badge-rightSection': {
      display: 'flex'
    }
  },
  leftSection: {
    display: 'flex',
    alignItems: 'flex-start',
    '& .mantine-Menu-dropdown': {
      padding: theme.spacing.sm
    }
  },
  rightSection: {
    display: 'flex',
    alignItems: 'flex-end',
    marginRight: theme.spacing.xs
  },

  menu: {
    // height: '180px',
    marginBottom: '10px',
    padding: theme.spacing.sm
  }
}));
